import { render, staticRenderFns } from "./OrganizationsPaginatedTable.vue?vue&type=template&id=9b29be1a&scoped=true"
import script from "./OrganizationsPaginatedTable.vue?vue&type=script&lang=js"
export * from "./OrganizationsPaginatedTable.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsPaginatedTable.vue?vue&type=style&index=0&id=9b29be1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b29be1a",
  null
  
)

export default component.exports